import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_Value } from '../../../../../../_entity/value/index.js';
import { MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import './ExpressionBuilder_SeverityDeclarations.scss';
import { QColorPicker_BackgroundForeground } from '../../../../../q-components/index.js';
import { Grid } from '@nu-art/thunderstorm-frontend';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import React from 'react';
/**
 * Visualizer and color editor for severity declarations for expressions from type score
 */
export class ExpressionBuilder_SeverityDeclarations extends TS_EditableItemComponent {
    /**
     * Resolve the value label to render
     * @param data The current rendered sub range data
     */
    resolveLabel = (data) => {
        return _jsx("div", { className: 'label', children: data.label });
    };
    /**
     * Resolve the value range to render
     * @param data The current rendered sub range data
     */
    resolveRange = (data) => {
        return _jsxs("div", { className: 'label', children: [data.scope[0], " - ", data.scope[1]] });
    };
    /**
     * Sort all current expression declarations by the first value of each sub range
     */
    sortDeclarations = () => {
        return sortArray(this.state.editable.item, i => {
            const subRange = ModuleFE_Value.cache.unique(i.severityValue);
            if (!subRange)
                throw new MUSTNeverHappenException(`cannot find sub range with id ${i.severityValue}`);
            return subRange.data.scope[0];
        });
    };
    render() {
        const declarations = this.sortDeclarations();
        return _jsx(Grid, { id: 'severity-declarations', children: declarations.map((severityDeclaration, index) => {
                const subRange = ModuleFE_Value.cache.unique(severityDeclaration.severityValue);
                if (!subRange)
                    throw new MUSTNeverHappenException(`cannot find sub range with id ${severityDeclaration.severityValue}`);
                const severityColors = ['#71CC8B', '#EAA751', '#FF8A88'];
                return _jsxs(React.Fragment, { children: [this.resolveLabel(subRange.data), this.resolveRange(subRange.data), _jsx(QColorPicker_BackgroundForeground, { disabled: this.props.viewMode, foregroundColor: severityDeclaration.color, backgroundColor: severityDeclaration.color, onBackgroundChange: async (color) => {
                                const severity = this.state.editable.editProp(index, {});
                                await severity.update('color', color);
                            }, onForegroundChange: async (color) => {
                                const severity = this.state.editable.editProp(index, {});
                                await severity.update('color', color);
                            }, colors: severityColors, backgroundColors: severityColors })] }, index);
            }) });
    }
}
//# sourceMappingURL=ExpressionBuilder_SeverityDeclarations.js.map